var Flickity = require("flickity")

let durationArticleSlider = 4
let intervalArticleSlider = 10
let articleSliders = []

$(initSliders)

$(window).on("resize", resizeSliders)

function resizeSliders() {
  articleSliders.forEach((s, i) => {
    const slider = articleSliders[i]
    if (slider) {
      requestAnimationFrame(function () {
        slider.resize()
      })
    }
  })
}

function initSliders() {
  console.log("Sliders are starting")
  $(".article-slider-container").each(function () {
    const container = $(this)

    if (container.attr("data-carousel-duration")) {
      durationArticleSlider = $(container).attr("data-carousel-duration")
    }
    const articleSlider = new Flickity(container[0], {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: true,
      draggable: true,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      on: {
        ready: function () {
          container.find(".slider-item").each(function () {
            $(this).css("opacity", "1")
          })
        },
        change: function (index) {
          track("Article Slider", "Slide " + (index + 1) + " Shown")
        },
        dragStart: function () {
          $(".slider-item").css("pointer-events", "none")
        },
        dragEnd: function () {
          $(".slider-item").css("pointer-events", "all")
        },
      },
    })

    articleSliders.push(articleSlider)

    container.parent().find(".flickity-page-dots .dot").html("<span></span>")

    container.find(".flickity-page-dots").appendTo(container.parents().find(".article-slider-dots-container"))

    container.parent().on("mouseleave", function () {
      container.attr("is-paused", "false")
    })

    container
      .parent()
      .find(".flickity-page-dots .dot")
      .on("click", function () {
        container.attr("is-paused", "true")
      })

    startProgressbarArticleSlider(articleSlider)
  })

  $(".article-slider .flickity-page-dots .dot").on("DOMSubtreeModified", function () {
    $(".article-slider-dots-container .dot span").css("width", "0%")
    $(".article-slider-dots-container .dot.is-selected span").css("width", 0 + "%")
  })

  resizeSliders()
}

function startProgressbarArticleSlider(articleSlider) {
  $(".article-slider-dots-container .dot.is-selected span", articleSlider.element.parentElement).css("width", "0%")
  var percentTimeArticleSlider = 0
  var stepArticleSlider
  window.setInterval(function () {
    if ($(articleSlider.element).attr("is-paused") != "true") {
      stepArticleSlider = (durationArticleSlider * 1000) / intervalArticleSlider
      percentTimeArticleSlider += 100 / stepArticleSlider

      $(".article-slider-dots-container .dot span", articleSlider.element.parentElement).css("width", "0%")
      $(".article-slider-dots-container .dot.is-selected span", articleSlider.element.parentElement).css("width", percentTimeArticleSlider + "%")

      if (percentTimeArticleSlider >= 100) {
        articleSlider.next()
        percentTimeArticleSlider = 0
        track("Article Slider", "Next Auto")
        $(".article-slider-dots-container .dot span", articleSlider.element.parentElement).css("width", "0%")
        $(".article-slider-dots-container .dot.is-selected span", articleSlider.element.parentElement).css("width", 0 + "%")
      }
    }
  }, intervalArticleSlider)
}

$(document).on("click", ".article-slider-container .slider-item", function () {
  track("Article Slider", "Slide " + (parseInt($(this).attr("carousel-index")) + 1) + " CTA Clicked")
})
